import { render, staticRenderFns } from "./AdsNameTemplate.vue?vue&type=template&id=9204ca0c&scoped=true&"
import script from "./AdsNameTemplate.vue?vue&type=script&lang=ts&"
export * from "./AdsNameTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./AdsNameTemplate.vue?vue&type=style&index=0&id=9204ca0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9204ca0c",
  null
  
)

export default component.exports